import { MATCHER_PHONE_VALIDATION_REGEX } from '../schemas/MatcherPhoneValidationRegex';

function matcherPhoneNumberIsValid(number = ''): boolean {
  return MATCHER_PHONE_VALIDATION_REGEX.test(number.replace(/\D/g, ''));
}

export { matcherPhoneNumberIsValid };
